<div class="p-8">
    <mat-card class="my-12">
        <h3>{{"CASES.FOLLOW_UP_ACTIONS.SECTION_ACTIONS_PROPORSAL" | translate}}</h3>
        <mat-card-content>
            <ng-container *ngFor="let task of followUpTasks">
                <div *ngIf="task?.followUpTaskId" class="p-12">
                    <mat-checkbox [checked]="task.selected" (change)="onCheckTask($event, task.followUpTaskId)">
                        <p>{{task?.description}}</p>
                    </mat-checkbox>
                    <mat-divider></mat-divider>
                </div>
            </ng-container>
        </mat-card-content>
    </mat-card>
    
    <mat-card class="my-12">
        <div fxLayout="row" style="justify-content: space-between;">
            <h3>{{"CASES.FOLLOW_UP_ACTIONS.SECTION_MANUAL_ACTIONS" | translate}}</h3>
            <button mat-raised-button color="primary" style="max-height: 40px;" class="mx-16 mt-8" matTooltip="{{'CASES.FOLLOW_UP_ACTIONS.ADD_ACTION' | translate}}"
                matTooltipPosition="above" (click)="onCreateAction()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-card-content>
            <ng-container *ngFor="let task of followUpTasks">
                <div *ngIf="!task?.followUpTaskId" class="p-12">
                    <div style="display: flex; font-size: 1.7rem;">
                        <p>{{task?.description}}</p>
                        <button mat-icon-button color="primary" class="mx-16 mt-8" matTooltip="{{'COMMON_LIST.ACTIONS.DELETE' | translate}}"
                            matTooltipPosition="above" (click)="deleteTask(task.description)">
                            <mat-icon>delete_outline</mat-icon>
                        </button>
                    </div>
                    <mat-divider></mat-divider>
                </div>
            </ng-container>
        </mat-card-content>
    </mat-card>
</div>
